import React, { useContext, useEffect, useState } from "react";
import Slider from "react-slick";
import { getProductDetails } from "./product-details-modal.service";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { AuthContext } from "../../contexts/AuthContext";
import { CartContext } from "../../contexts/CartContext";
import { useNavigate } from "react-router-dom";
import { Minus, Plus } from "react-feather";

export default function ProductDetailModal({
  id,
  isOpen,
  onClose,
}: {
  id: string;
  isOpen: boolean;
  onClose: () => void;
}) {
  const [productDetails, setProductDetails] = useState<any>({});
  const [loader, setLoader] = useState<boolean>(true);
  const { user } = useContext(AuthContext);
  const { handleAddToCart, cartItems } = useContext(CartContext);
  const [quantity, setQuantity] = useState<number>(1);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      setLoader(true);
      getProductDetails(id).then((res) => {
        setProductDetails(res.data);
        setLoader(false);
      });
    }
  }, [isOpen, id]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const thumbnailSettings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
  };

  const isSample = false;

  if (loader) {
    return <div className="loader"></div>;
  }

  const images = Array.isArray(productDetails.images)
    ? [...productDetails.images]
    : [];

  if (images.length === 1) {
    images.push(images[0]);
  }

  const productInCart = cartItems.find((item: any) => item.productId === id);

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      {loader ? (
        <div className="loader"></div>
      ) : (
        <div className="modal-content">
          <div className="modal-body">
            <button
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
              }}
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
            <div className="row">
              <div className="col-md-5 col-sm-12 col-xs-12">
                <Slider {...settings} className="qty-product-cover">
                  {images.map((image: any, index: number) => (
                    <div className="qty-slide" key={index}>
                      <img
                        className="img-responsive"
                        src={`https://d1gdand68muq63.cloudfront.net/${
                          productDetails.isSample
                            ? "sample-products"
                            : "products"
                        }/original/${image.key}`}
                        alt={`Product image ${index + 1}`}
                      />
                    </div>
                  ))}
                </Slider>
                <Slider {...thumbnailSettings} className="qty-nav-thumb">
                  {images.map((image: any, index: number) => (
                    <div className="qty-slide" key={index}>
                      <img
                        className="img-responsive"
                        src={`https://d1gdand68muq63.cloudfront.net/${
                          productDetails.isSample
                            ? "sample-products"
                            : "products"
                        }/96/${image.key}`}
                        alt={`Thumbnail image ${index + 1}`}
                      />
                    </div>
                  ))}
                </Slider>
              </div>
              <div className="col-md-7 col-sm-12 col-xs-12">
                <div className="quickview-pro-content">
                  <h5 className="ec-quick-title">
                    <a>{productDetails.code}</a>
                  </h5>
                  <div className="ec-quickview-desc">{productDetails.name}</div>
                  <div className="variable-single-item">
                    <span className="mb-0 mt-1">
                      Available Stock: {productDetails.quantity}
                    </span>
                    <table className="w-25 table table-bordered">
                      <thead>
                        <tr>
                          <td>Dimensions</td>
                          <td>Length</td>
                          <td>Width</td>
                          <td>Height</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td scope="row">Centimeter</td>
                          <td>{productDetails.centimeter.length}</td>
                          <td>{productDetails.centimeter.width}</td>
                          <td>{productDetails.centimeter.height}</td>
                        </tr>
                        <tr>
                          <td scope="row">Inches</td>
                          <td>{productDetails.inch.length}</td>
                          <td>{productDetails.inch.width}</td>
                          <td>{productDetails.inch.height}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {user.userType === "Buyer" ? (
                    <div className="ec-quickview-qty">
                      <div className="qty-plus-minus">
                        <button
                          type="button"
                          className="qty-btn qty-btn-minus"
                          aria-label="Decrease quantity"
                          onClick={() =>
                            setQuantity((prev) => Math.max(1, prev - 1))
                          }
                          disabled={quantity <= 1}
                        >
                          <Minus size={16} />
                        </button>
                        <input
                          className="qty-input"
                          type="text"
                          name="ec_qtybtn"
                          value={quantity}
                          onChange={(event) => {
                            const parsedValue = Number(event.target.value);
                            const maxQty = productDetails.quantity || 1;
                            if (
                              Number.isFinite(parsedValue) &&
                              parsedValue > 0 &&
                              parsedValue <= maxQty
                            ) {
                              setQuantity(parsedValue);
                            } else if (event.target.value === "") {
                              setQuantity(1);
                            }
                          }}
                        />
                        <button
                          type="button"
                          className="qty-btn qty-btn-plus"
                          aria-label="Increase quantity"
                          onClick={() =>
                            setQuantity((prev) =>
                              Math.min(productDetails.quantity || 1, prev + 1),
                            )
                          }
                          disabled={quantity >= (productDetails.quantity || 1)}
                        >
                          <Plus size={16} />
                        </button>
                      </div>
                      <div className="ec-quickview-cart ">
                        <Button
                          variant="primary"
                          onClick={() => {
                            if (productInCart) {
                              navigate("/cart");
                              return;
                            }

                            handleAddToCart({ productId: id, quantity });
                          }}
                        >
                          {productInCart ? (
                            "View Cart"
                          ) : (
                            <>
                              <img
                                src="assets/images/icons/cart.svg"
                                className="svg_img pro_svg"
                                alt=""
                              />{" "}
                              Add To Cart
                            </>
                          )}
                        </Button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
}
